/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	export enum Environment {
		Web = 'env-web',
		App = 'env-app',
	}
}
